import { useRef, useState } from 'react';
import PhotosAPI from '../../../../Services/PhotosAPI';
import { UPLOAD_STATUS } from './constants';

export const UPLOAD_ERROR_MESSAGE =
  'The image failed to upload. Please try again.';

export const useImageUpload = ({ file, onImageUpload, photoUploadKey }) => {
  const [description, setDescription] = useState('');
  const [progressValue, setProgressValue] = useState(0);
  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const [uploadStatus, setUploadStatus] = useState(UPLOAD_STATUS.READY);

  const uploadRequestRef = useRef();

  const resetUpload = () => {
    setProgressValue(0);
    setUploadStatus(UPLOAD_STATUS.READY);
    setUploadErrorMessage('');
  };

  const abortImageUpload = () => {
    if (uploadStatus === UPLOAD_STATUS.UPLOADING) {
      setUploadStatus(UPLOAD_STATUS.CANCELING);
      uploadRequestRef.current && uploadRequestRef.current.abort();
    }
  };

  const onUploadAbort = () => {
    resetUpload();
  };

  const onUploadFailure = () => {
    setUploadErrorMessage(UPLOAD_ERROR_MESSAGE);
    setProgressValue(0);
    setUploadStatus(UPLOAD_STATUS.FAILURE);
  };

  const onUploadProgress = (event) => {
    const { loaded, total } = event;
    const uploadPercentage = Math.floor((loaded / total) * 100);

    setProgressValue(uploadPercentage);
    if (uploadPercentage === 100) {
      setUploadStatus(UPLOAD_STATUS.COMPLETE);
    }
  };

  const onUploadSuccess = (event) => {
    const { status, responseText } = event.target;
    if (status !== 200) {
      onUploadFailure();
      return;
    }

    const response = JSON.parse(responseText);
    const { clUrl, thumbUrl, url } = response.photos[0];

    setUploadStatus(null);
    onImageUpload({
      clUrl,
      ...(description && { description }),
      thumbUrl,
      url,
    });
  };

  const uploadImage = () => {
    setUploadStatus(UPLOAD_STATUS.UPLOADING);
    const xhr = PhotosAPI.uploadForKey(
      photoUploadKey,
      [file],
      onUploadSuccess,
      onUploadProgress,
      onUploadFailure,
      onUploadAbort,
    );

    uploadRequestRef.current = xhr;
  };

  return {
    abortImageUpload,
    description,
    progressValue,
    resetUpload,
    setDescription,
    uploadErrorMessage,
    uploadImage,
    uploadStatus,
  };
};
